import VueComponent from "./vue/component.vue"
export default VueComponent;